import {Input, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {TooltipComponent} from './tooltip.component';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
  declarations: [TooltipComponent],
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  exports: [
    TooltipComponent
  ]
})

export class TooltipModule { }
